/**
 * Request Status Collection.
 *
 * Contains static list of available ticket's message types, which can be used for different
 * purposes, like filling lists, allowing options selection, etc.
 */
export default [
  {
    key: 0,
    value: 'Draft',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 2,
    value: 'Outbox',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 10,
    value: 'Logged',
    icon: {
      name: 'dot',
    },
    color: 'pending',
    backgroundColor: 'pending.50',
  },
  {
    key: 50,
    value: 'Further inquiry',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 60,
    value: 'In progress',
    icon: {
      name: 'dot',
    },
    color: 'warning.700',
    backgroundColor: 'warning.50',
  },
  {
    key: 75,
    value: 'Evaluate solution',
    icon: {
      name: 'dot',
    },
    color: 'pending.500',
    backgroundColor: 'pending.50',
  },
  {
    key: 80,
    value: 'Closed',
    icon: {
      name: 'dot',
    },
    color: 'gray.500',
    backgroundColor: 'gray.950',
  },
]
